import config from "../../configuration";

const buildApiUrl = (path: string): string => {
    return new URL(path, config.safe2DriveApiBaseUrl).href;
};

export default buildApiUrl;
